module.exports = __webpack_public_path__ + "img/course.d0222f17.png";